<template>
  <div class="relative">
     <video ref="video" autoplay muted playsinline style="position: absolute;top:0;left: 0;z-index: 0;"></video>
     <div  style="position: absolute;top:0;left: 0;z-index: 1;" >
     
     <canvas ref="canvas" rounded-2x></canvas>

     <div  class="relative z-20 pt-3">
       <p class=" text-center dark:text-n0 font-medium   text-center text-sm p-1">
              Toleh Ke kiri dan kanan untuk absen
             </p>
     </div>

      <div v-if="false" class="relative z-20 pt-3">
        <div class="flex gap-3 justify-start items-center">
          <div class="bg-g300 rounded-2xl p-4 flex-1   flex flex-col justify-center items-center shrink-0"  @click="manualCapture" >          
            <p class=" text-center dark:text-n0 font-medium text-white text-center text-sm p-2">
              Capture
             </p>
          </div>   
        </div>
      </div>

     </div>

      <pulse-loader :loading="loading" :color="color" :size="size" style="position: absolute;top:150px;right: 150px;"></pulse-loader>
    
  </div>
  <p>{{ status }}</p>
  <div style="z-index: 9999;margin-top: 300px;">
 <p class="relative  text-center">{{ status }}</p>
  
   
   <!-- <button @click="switchCamera()">🔄 Ganti Kamera</button>   -->
   </div>



</template>

<script setup>
import * as faceapi from 'face-api.js'
import { ref, onMounted, onBeforeUnmount,defineProps, defineEmits } from 'vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
 

const props = defineProps({
  enableLiveness: { type: Boolean, default: false }
})
const emit = defineEmits(["livenessPassed","manualCapture"])

const video = ref(null)
const canvas = ref(null)
const status = ref("Loading models...")
const loading = ref(false)

//let lastEyeRatio = 0
//let blinkCount = 0
 let currentFacingMode = "user"
let descriptor = null

//const EAR_THRESHOLD = 0.25     // ambang batas
//const CONSEC_FRAMES = 3         // minimal frame berturut-turut
//let frameCounter = 0 
//let lastBlinkTime = 0
let detectInterval = null
let stream = null

let kiri = 0;
let kanan = 0;
let hadap = 'depan'

async function startCamera(facingMode = "user") {
  stream = await navigator.mediaDevices.getUserMedia({ video: {facingMode: facingMode} })
  video.value.srcObject = stream

  video.value.onloadedmetadata = () => {
    // ✅ set ukuran video & canvas sama
    video.value.width = video.value.videoWidth
    video.value.height = video.value.videoHeight
    canvas.value.width = video.value.videoWidth
    canvas.value.height = video.value.videoHeight
  }
}

   async function switchCamera() {
    if (detectInterval) clearInterval(detectInterval)

    if (stream) {
      stream.getTracks().forEach(track => track.stop()) // matiin kamera
    }

    if (video.value) {
      video.value.srcObject = null
    }
    if(currentFacingMode === "user"){
        currentFacingMode = "environment"
    }else{
         currentFacingMode = "user"
    }
    //const newMode = currentFacingMode === "user" ? "environment" : "user"
    await startCamera(currentFacingMode)
 }  

onMounted(async () => {
  await faceapi.nets.tinyFaceDetector.loadFromUri('/models')
  await faceapi.nets.faceLandmark68Net.loadFromUri('/models')
  await faceapi.nets.faceRecognitionNet.loadFromUri('/models')//face_recognition_model-weights_manifest.json
  status.value = "Models loaded"
  await startCamera()

//  const stream = await navigator.mediaDevices.getUserMedia({ video: true })
 // video.value.srcObject = stream

  video.value.onplay = () => {
    const displaySize = { width: video.value.width, height: video.value.height }
    faceapi.matchDimensions(canvas.value, displaySize)

   detectInterval  = setInterval(async () => {
      const detections = await faceapi.detectSingleFace(video.value, new faceapi.TinyFaceDetectorOptions()).withFaceLandmarks().withFaceDescriptor()
      const ctx = canvas.value.getContext('2d')
      ctx.clearRect(0, 0, canvas.value.width, canvas.value.height)


     

      if (detections) {
        status.value = "Wajah terdeteksi!"
         descriptor = Array.from(detections.descriptor)
        const resized = faceapi.resizeResults(detections, displaySize)
        faceapi.draw.drawDetections(canvas.value, resized)
      // faceapi.draw.drawFaceLandmarks(canvas.value, resized)
        if (props.enableLiveness) {
         // detectBlink(detections.landmarks)
          const direction = detectHeadTurn(detections.landmarks)
          status.value = `Wajah terdeteksi (${direction})`
        }
      } else {
        status.value = "Tidak ada wajah"
      }
    }, 500)
  }
})

onBeforeUnmount(() => {
  if (detectInterval) clearInterval(detectInterval)

  if (stream) {
    stream.getTracks().forEach(track => track.stop()) // matiin kamera
  }

  if (video.value) {
    video.value.srcObject = null
  }
})

 
function detectHeadTurn(landmarks) {

  if(kanan>2 && kiri > 2){
     manualCapture()
  }
  const nose = landmarks.getNose()
  const leftEye = landmarks.getLeftEye()
  const rightEye = landmarks.getRightEye()

  // rata-rata posisi mata
  const leftEyeCenter = avgPoint(leftEye)
  const rightEyeCenter = avgPoint(rightEye)
  const eyeCenterX = (leftEyeCenter.x + rightEyeCenter.x) / 2

  // posisi hidung tengah (ujung hidung)
  const noseTip = nose[3] // titik ujung hidung

  // selisih horizontal antara hidung & tengah mata
  const dx = noseTip.x - eyeCenterX
  const faceWidth = rightEyeCenter.x - leftEyeCenter.x

  const ratio = dx / faceWidth

  if (ratio > 0.15) {
    if(hadap != 'kanan'){
      kanan = kanan+1
    }
    hadap = 'kanan'
    
    return "➡️ Toleh kanan " + kanan + ' x'
  } else if (ratio < -0.15) {
     if(hadap != 'kiri'){
      kiri = kiri+1
    }
     hadap = 'kiri'
     
    return "⬅️ Toleh kiri " + kiri + 'x'
  } else {     
     hadap = 'depan'
    return "⬆️ Hadap depan"
  }
}

function avgPoint(points) {
  const sumX = points.reduce((a, p) => a + p.x, 0)
  const sumY = points.reduce((a, p) => a + p.y, 0)
  return { x: sumX / points.length, y: sumY / points.length }
}

function capture() {
  kanan=0
  kiri=0
 // const ctx = canvas.value.getContext("2d")
 // ctx.drawImage(video.value, 0, 0, canvas.value.width, canvas.value.height)
  return descriptor //canvas.value.toDataURL("image/png")
}

async function manualCapture() {
   kanan=0
  kiri=0

  loading.value = true
 
  status.value = "Foto diambil manual"
const token = localStorage.getItem("token");
   const res = await fetch("https://kiyanrahayu.my.id/api2/faces",{
      headers: {         
        "Authorization": "Bearer " + token,
         "Accept": "application/json"
       }
    })
   const faces = await res.json() 
   let bestMatch = { user_id: null, distance: 999 }

   if(descriptor){

      for (let face of faces) {
        const dbDescriptor = new Float32Array( JSON.parse(face.datawajah))

        console.log(JSON.parse(face.datawajah));
        console.log("================");
        console.log(descriptor);
        const distance = faceapi.euclideanDistance(descriptor, dbDescriptor)
        if (distance < bestMatch.distance) {
          bestMatch = { user_id: face.nama, distance }
        }
      }

      if (bestMatch.distance < 0.6) {
        //status.value = `Wajah cocok dengan user_id ${bestMatch.user_id}`
         loading.value = false
        console.log(`Wajah cocok dengan user_id ${bestMatch.user_id}`)
        emit("livenessPassed",{ msg: `Wajah cocok dengan user_id ${bestMatch.user_id}`,sts:true})

      } else {
         loading.value = false
        console.log('error')
        emit("livenessPassed", { msg:"Wajah tidak dikenali",sts:false})
        //status.value = "Wajah tidak dikenali"
      }
    }else{
       loading.value = false
       emit("livenessPassed", { msg: "Wajah tidak dikenali",sts:false})
    }

//  emit("livenessPassed", img)   // kirim ke parent
}

// eslint-disable-next-line no-undef
defineExpose({ capture ,manualCapture,switchCamera})
</script>

<style scoped>
.relative {
  width: 100%;
  max-width: 500px;
  position: relative;
}
video,
canvas {
  width: 100%;   /* biar responsive */
  height: auto;
}
</style>